<template>
    <div v-loading="loading">
        <div class="mak-text-md d-flex justify-end mb-4">
            <b>Toplam:</b> {{ toplam }} kontrol/aylık
        </div>

        <v-expansion-panels v-model="activePanel">
            <v-expansion-panel
                v-for="(kontrol, index) in gunlukKontroller"
                :key="`${ index }-kontrol`"
            >
                <v-expansion-panel-header>
                    <div class="d-flex justify-space-between">
                        <div>Ayın <b>{{ kontrol.ayin_gunu }}.</b> günü</div>
                        <div><b>{{ kontrol.kontrol_sayisi }}</b> tane kontrol</div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-overlay absolute :value="loadingMusteriler">
                        <v-progress-circular indeterminate size="64"/>
                    </v-overlay>
                    <v-data-table
                        :items="musteriler"
                        :headers="headers"
                        :key="`${ index }-gunluk-kontroller`"
                        :disable-pagination="true"
                        hide-default-footer
                    >
                        <template #item.index="{ index }">
                            {{ index + 1 }}
                        </template>
                        <template #item.baslangic_zamani="{ item }">
                            <div class="grey--text">
                                {{ formatDateTime(item.baslangic_zamani) }}
                            </div>
                        </template>
                        <template #item.actions="{ item }">
                            <v-btn
                                small
                                @click="change(item)"
                            >
                                <v-icon>mdi-refresh</v-icon>
                                Değiştir
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-dialog
            v-model="visible"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar
                    dark
                    color="indigo"
                >
                    <v-btn
                        icon
                        dark
                        @click="visible = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        Kontrol Zamanı Güncelle
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            dark
                            text
                            @click="visible = false"
                        >
                            Vazgeç
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <div class="my-8 mx-4">
                    <v-overlay absolute :value="loadingGuncelle">
                        <v-progress-circular indeterminate size="64"/>
                    </v-overlay>

                    <v-select
                        v-model="selectedDay"
                        :items="dayList"
                        item-text="text"
                        item-value="value"
                        label="Yeni kontrol günü seçiniz"
                    />
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Formatter from '@/mixins/Formatter.js';
    import { DEFAULT_DATE_FORMAT } from '@/common/utils.js';
    import moment from 'moment';

    export default {
        name: 'mak-kontrol-planlama',
        mixins: [Formatter],
        data() {
            return {
                activePanel: null,
                visible: false,
                loading: false,
                loadingMusteriler: false,
                loadingGuncelle: false,
                gunlukKontroller: [],
                musteriler: [],
                selectedDay: null,
                selectedMusteri: null,
            };
        },
        computed: {
            headers() {
                return [
                    { text: '#', value: 'index', width: 40 },
                    { text: 'Musteri', value: 'sirket_adi' },
                    { text: 'Kontrol zamanı', value: 'baslangic_zamani', width: 100 },
                    { text: '', value: 'actions' },
                ];
            },
            toplam() {
                return this.gunlukKontroller.reduce((sonuc, el) => (sonuc += el.kontrol_sayisi, sonuc), 0);
            },
            disabledDay() {
                if (this.selectedMusteri) {
                    return moment(this.selectedMusteri.baslangic_zamani, DEFAULT_DATE_FORMAT).get('date');
                }
                return false;
            },
            dayList() {
                return new Array(30)
                    .fill('')
                    .map((a, i) => ({
                        value: i + 1,
                        text: `Ayın ${ i + 1 }. günü`,
                    }));
            },
        },
        methods: {
            fetch() {
                this.loading = true;
                this.$requests.MusteriKontrol
                    .getMusteriKontrolGenelGorunum()
                    .then((data) => {
                        this.gunlukKontroller = (data || []).map(d => ({
                            kontrol_sayisi: parseInt(d.kontrol_sayisi),
                            ayin_gunu: parseInt(d.ayin_gunu),
                        }));
                    })
                    .catch((error) => {
                        console.error(`error on loading getMusteriKontrolGenelGorunum`, error);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            fetchGunlukKontroller(day) {
                if (!day) {
                    return;
                }
                this.loadingMusteriler = true;
                this.musteriler = [];
                this.$requests.Musteri
                    .getMusteriGunlukKontroller(day)
                    .then((data) => {
                        this.musteriler = (data || []);
                    })
                    .catch((error) => {
                        console.error(`error on loading fetchGunlukKontroller`, error);
                    })
                    .then(() => {
                        this.loadingMusteriler = false;
                    });
            },
            updateKontrolZamani(day) {
                if (!this.selectedMusteri) {
                    return;
                }
                const dt = moment(this.selectedMusteri.baslangic_zamani, DEFAULT_DATE_FORMAT).set('date', day);
                const id = this.selectedMusteri.id;
                const data = {
                    kontrol_zamani: dt.format(DEFAULT_DATE_FORMAT),
                };
                this.loadingGuncelle = true;
                this.$requests.Musteri
                    .updateMusteriKontrolZamani(id, data)
                    .then((data) => {
                        this.musteriler = (data || []);

                        const days = this.gunlukKontroller.map(d => d.ayin_gunu);
                        this.activePanel = days.indexOf(this.selectedDay);

                        // rest form and update data
                        this.fetch();
                        this.reset();
                    })
                    .catch((error) => {
                        console.error(`error on loading updateMusteriKontrolZamani`, error);
                    })
                    .then(() => {
                        this.loadingGuncelle = false;
                    })
            },
            reset() {
                this.visible = false;
                this.selectedDay = null;
                this.selectedMusteri = null
            },
            change(musteri) {
                this.selectedMusteri = musteri;
                this.visible = true;
            },
        },
        mounted() {
            this.fetch();
        },
        watch: {
            activePanel() {
                const kontrol = this.gunlukKontroller[this.activePanel];
                this.fetchGunlukKontroller(kontrol?.ayin_gunu)
            },
            selectedDay() {
                this.updateKontrolZamani(this.selectedDay);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .mak-text-md {
        font-size: 1.3rem;
    }
    .mak-kontrol-satiri {
        width: 100%;
        padding-right: 20px;
    }
    .el-table {
        ::v-deep .cell {
            font-size: 1.2em;
        }
    }
    ::v-deep .el-dialog__wrapper {
        .el-select {
            width: 70%;

            .el-input {
                font-size: 1.3rem;
            }
        }
    }
</style>
